import React from "react";
import { match } from "ts-pattern";

import { ChartIcon } from "src/assets/icons/chart_icon";
import { ChevronRightIcon } from "src/assets/icons/chevron_right_icon";
import { FileCheckIcon } from "src/assets/icons/file_check_icon";
import { PaperPlaneIcon } from "src/assets/icons/paper_plane_icon";
import { UsersIcon } from "src/assets/icons/users_icon";

import "./cta.scss";

/*
 * Types
 */

export interface CTAProps {
    readonly color: "blue" | "grey" | "gold";
    readonly icon: "chart" | "file-check" | "paper-plane" | "users";
    readonly onClick?: () => void;
    readonly subtitle: string;
    readonly title: string;
}

/*
 * Main
 */

export const CTA = (props: CTAProps): React.ReactElement => {
    const { color, icon, onClick, subtitle, title, ...rest } = props;

    const renderIcon = () => {
        return match(icon)
            .with("chart", () => <ChartIcon />)
            .with("file-check", () => <FileCheckIcon />)
            .with("paper-plane", () => <PaperPlaneIcon />)
            .with("users", () => <UsersIcon />)
            .exhaustive();
    };

    return (
        <button className={`large-cta-button ${color}`} onClick={(): void => onClick && onClick()} {...rest}>
            <div className="cta-line-1">{subtitle}</div>
            <div className="cta-line-2">
                {renderIcon()}
                {title}
            </div>
            <div className="arrow-icon">
                <ChevronRightIcon />
            </div>
        </button>
    );
};
